// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"653c787f2490dc24","5227":"84fbe78f96330136","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};